/**
 * Which single characters a person may type into a room-code box.
 *
 * Derived from `@interlock/protocol`, never written out: a character is
 * typeable when `normaliseRoomCode` turns it into one of the room alphabet's
 * own. That is the alphabet itself plus the misreadings it folds back (`O`
 * for `Q`, `1` for `J`, …), so the leniency the server already has for a
 * code read aloud survives the box that filters what is typed. A character
 * that folds onto nothing (`S`, `5`, `Z`, `2`, `B`, `8`) cannot be part of any
 * code, and cannot be typed.
 */
import { ROOM_CODE_ALPHABET, normaliseRoomCode } from '@interlock/protocol';

/** Letters and digits: every character a code could be typed with before folding. */
const CANDIDATES = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

/** The characters that survive: `normaliseRoomCode` folds each onto the room alphabet. */
export const ROOM_CODE_TYPEABLE_CHARACTERS: string = [...CANDIDATES]
  .filter((character) => ROOM_CODE_ALPHABET.includes(normaliseRoomCode(character)))
  .join('');

/** One typeable character, for the shell's `CodeBoxes` (`allowed`), tested after upper-casing. */
export const ROOM_CODE_TYPEABLE = new RegExp(`[${ROOM_CODE_TYPEABLE_CHARACTERS}]`);
